import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Table from './TableMessage';
import SearchForm from './SearchForm';

export default class Message extends Component {
    constructor(props) {
        super(props);
        this.state = {
            messages: [],
            searchConditions: {},
            lastPage: 1,
            currentPage: 1,
            removeDirectlyClick: 1,
            from: '',
            to: '',
            total: '',
        };
        this.handleSearch = this.handleSearch.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.handleDetail = this.handleDetail.bind(this);
    }

    /**
     * Init data and form cash or list cash
     */
    componentWillMount() {
        const keySearch_str = this.props.location.search.substring(1);
        let keySearch_arr = {page: 1};
        if(keySearch_str){
            keySearch_arr = JSON.parse('{"' + decodeURI(keySearch_str.replace(/&/g, "\",\"")).replace(/=/g,"\":\"").replace('%3A', ':') + '"}');
        }

        //always get list data
        axios.post('/api/houjin/messages/search', keySearch_arr).then(response => {
            this.setState({
                messages: response.data.data,
                lastPage: response.data.last_page,
                currentPage: response.data.current_page,
                searchConditions: keySearch_arr,
                from: response.data.from,
                to: response.data.to,
                total: response.data.total,
            });
            this.props.history.push({
                search: keySearch_str
            });
        });
    }

    /**
     * Sort data
     */
    handleSort(key) {
        //add sort params to search conditions
        let newSearchConditions = this.state.searchConditions;
        newSearchConditions.sort_column = key.sort_column;
        newSearchConditions.sort_type = key.sort_type;
        this.setState({
            searchConditions: newSearchConditions
        });
        axios.post('/api/houjin/messages/search', newSearchConditions).then(response => {
            this.setState({
                messages: response.data.data,
                lastPage: response.data.last_page,
                currentPage: response.data.current_page,
                from: response.data.from,
                to: response.data.to,
                total: response.data.total,
            });
            this.props.history.push({
                search: $.param(newSearchConditions)
            });
        });
    }

    /**
     * Get search data
     */
    handleSearch(key) {
        this.setState({
            searchConditions: key
        });
        axios.post('/api/houjin/messages/search', key).then(response => {
            this.setState({
                messages: response.data.data,
                lastPage: response.data.last_page,
                currentPage: response.data.current_page,
                from: response.data.from,
                to: response.data.to,
                total: response.data.total,
            });
            this.props.history.push({
                search: $.param(key)
            });
        });
    }

    /**
     * Handle redirect
     */
    handleRedirect(e) {
        e.preventDefault()
        this.props.history.push(e.currentTarget.getAttribute('href'));
    }
    handleDetail(messageDetail) {
        let request = {
            'job_id':messageDetail.message_threads_job_id,
            'staff_id': messageDetail.staff_id,
            'client_id': messageDetail.client_id,
        }
        axios.post('/api/houjin/message/redirect-to-job-apply', request).then(response => {
            if (response) {
                this.props.history.push('/houjin/jobapplys/edit/' + response.data.id + '?from=message');
            }
        });
    }

    render () {
        const columns = [
            {name: 'id', title: 'ID', isSort: 1, type: 'text_comment_id_new'},
            {name: 'message_threads_job_id', title: '依頼ID', isSort: 1, type: 'link_job_edit_houjin'},
            {name: 'message_categories_name', title: '依頼名', isSort: 0, type: 'text_message_categories_name'},
            {name: 'message_flg', title: '発信者', isSort: 1, type: 'option', option:{1:{text:'依頼者',classHTML:'badge bg-pink text-white'}, 2:{text:'ワーカー', classHTML:'badge bg-purple text-white'} }},
            {name: 'staff_first_last_name', title: 'ワーカー名', isSort: 1, type: 'text', isSearch:true},
            {name: 'staff_id', title: 'ワーカーID', isSort: 1, type: 'text', isSearch:true},
            {name: 'message_content', title: '内容', isSort: 0, type: 'text_message_content', isSearch:true},
            {name: 'created_at', title: '送信日', isSort: 1, type: 'date_time'},
            {name: 'client_unread_flag', title: '', isSort: 0, type: 'filting'},
        ];
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-sm-12">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item"><a onClick={this.handleRedirect} href="/houjin/home">ダッシュボード</a></li>
                                <li className="breadcrumb-item active" aria-current="page">コメント履歴一覧</li>
                            </ol>
                        </nav>
                    </div>
		</div>

		<main id="main">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col">
                                            <h4 className="mt-2 mb-0 page-title">コメント履歴一覧</h4>
                                        </div>
                                        <div className="col text-right">
                                            <button className="btn btn-light" type="button" data-toggle="collapse" data-target="#search-messages" aria-expanded="false" aria-controls="search-messages">絞込検索</button>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <SearchForm onSearch={this.handleSearch} />
                                        </div>
                                    </div>
                                </div>
                                <Table onSearch={this.handleSearch} onEdit={this.handleDetail} header={columns} data={this.state.messages} onSort={this.handleSort} from={this.state.from} to={this.state.to} total={this.state.total}
                                myPagination={1} searchConditions={this.state.searchConditions} lastPage={this.state.lastPage} currentPage={this.state.currentPage} />
                            </div>
                        </div>
                    </div>
		</main>
            </React.Fragment>
        );
    }
}
